import React from 'react';
import { Route, Switch, Redirect } from "react-router-dom";

import Layout from './common/layout/main';
import { unifiedRoutes, mpmRoutes, ppmRoutes, ipmRoutes, prmRoutes, lpmRoutes, admRoutes, mpmExecutivePath } from './views/dashboard/routes';
import { configRoutes } from './views/user_inputs/routes';
import RouteNotFound from './views/misc/RouteNotFound';
import { trackerRoutes } from './views/tracker/routes';
import { companyRoutes } from './views/company/routes';
import store from './store.js';
import UnderMaintainance from './views/misc/UnderMaintainance.js';
import SignupRedirect from './components/SignupRedirect';

function App() {
  const dashboardRoute = (path) => path;
  const demoRoute = (path) => `/demo${path}`;

  const renderRoutes = (routes) => (
    routes.map((route) => <Route exact path={dashboardRoute(route.path)} render={route.render} />)
  );
  const renderDemoRoutes = (routes) => (
    routes.map((route) => <Route exact path={demoRoute(route.path)} render={route.render} />)
  );

  return (
      <Switch>
        {/* Signup route outside of Layout since it's a redirect */}
        <Route exact path="/signup" component={SignupRedirect} />

        <Layout>
          <Switch>

            {/* <Route path='*' exact component={UnderMaintainance} /> */}

            {/*{ renderRoutes(unifiedRoutes) }*/}
            { renderRoutes(mpmRoutes) }
            { renderRoutes(ppmRoutes) }
            { renderRoutes(ipmRoutes) }
            { renderRoutes(prmRoutes) }
            { renderRoutes(lpmRoutes) }
            { renderRoutes(admRoutes) }
            { renderRoutes(configRoutes) }
            { renderRoutes(trackerRoutes) }
            { renderRoutes(companyRoutes) }

            { renderDemoRoutes(unifiedRoutes) }
            { renderDemoRoutes(mpmRoutes) }
            { renderDemoRoutes(ppmRoutes) }
            { renderDemoRoutes(ipmRoutes) }
            { renderDemoRoutes(prmRoutes) }
            { renderDemoRoutes(lpmRoutes) }
            { renderDemoRoutes(admRoutes) }
            { renderDemoRoutes(configRoutes) }

            <Route exact path="/">
              <Redirect to={mpmExecutivePath} />
            </Route>

            <Route path='*' exact component={RouteNotFound} />
          </Switch>
        </Layout>
      </Switch>
  )
}

export default App;
